module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-11.1b37ed5c.png";